import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router';

/** Lets Astryx links and buttons with href navigate client-side through React Router. */
export const RouterLink = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string; to?: string }>(
  function RouterLink({ href, to, ...rest }, ref) {
    const target = to ?? href ?? '/';
    if (/^(https?:|tel:|mailto:)/.test(target) || rest.target === '_blank') {
      return <a ref={ref} href={target} {...rest} />;
    }
    return <Link ref={ref} to={target} {...rest} />;
  },
);
